import theme from "../../styles/Theme.styled";
import Box from "../Utils/Box.styled";
import Stack from "../Utils/Stack.styled";
import { motion } from "framer-motion";

const LoadingCard = ({ isDetail }) => {
  const loading = {
    show: {
      backgroundColor: [theme.colors.grey, "#D2DBE2", theme.colors.grey],
      transition: {
        duration: 1,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "linear",
      },
    },
  };
  return (
    <Stack direction="column" gap="16" height="fit-content">
      {!isDetail && (
        <Box
          as={motion.div}
          variants={loading}
          animate="show"
          height="160px"
          radius="8px"
        />
      )}
      <Stack gap="16" alignItems="center" height="fir-content">
        <Box
          as={motion.div}
          variants={loading}
          animate="show"
          height="40px"
          width="50px"
          radius="1000%"
        />
        <Stack direction="column" gap="8">
          <Box
            as={motion.div}
            variants={loading}
            animate="show"
            height="10px"
            radius="2px"
          />
          <Box
            as={motion.div}
            variants={loading}
            animate="show"
            height="10px"
            width="70%"
            radius="2px"
          />
          <Box
            as={motion.div}
            variants={loading}
            animate="show"
            height="10px"
            width="40%"
            radius="2px"
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default LoadingCard;
